// TODO: add react-helmet for document.title

import { AISearchPage } from "@models";
import {
    AI_SEARCH_ANSWER_PARAM,
    AI_SEARCH_QUERY_PARAM,
    BYO_INSTANT_CHART_ID_QUERY_PARAM_NAME, BYO_SETTINGS_ID_QUERY_PARAM_NAME, BYO_WORDS_COUNT_QUERY_PARAM_NAME
} from "@constants/general";

export const Routes = {
    Home: "/",
    menuExamples: "/menu-examples",
    reports: "/reports",
    instantCharts: "/instant-charts",
    instantChartsNew: "/instant-charts-new-temporary",
    foodProfile: "/food-profile",
    foodProfiles: "/food-profiles",
    topTrends: "/topTrends",
    byo: "/byo",
    byoSetting: "/saved-byo",
    instantChart: "/instant-chart",
    aiSearch: "/aiSearch",
};

export const AI_SEARCH_PAGE_ROUTES: Partial<Record<AISearchPage, string>> = {
    [AISearchPage.Undefined]: Routes.topTrends,
    [AISearchPage.Byo]: Routes.byo,
    [AISearchPage.TopTrends]: Routes.topTrends,
};

export const getSearchUrl = (
    page: AISearchPage,
    route: string,
    query: string
) => {
    const encoded = encodeURIComponent(query);
    const paramName = page === AISearchPage.Undefined ? AI_SEARCH_ANSWER_PARAM : AI_SEARCH_QUERY_PARAM;
    const param = `${paramName}=${encoded}`;
    return `${route}?${param}`;
};

export const getInstantChartUrl = (id: any, wordsCount: number) => {
    return `${Routes.instantChart}?${BYO_INSTANT_CHART_ID_QUERY_PARAM_NAME}=${encodeURIComponent(id)}&${BYO_WORDS_COUNT_QUERY_PARAM_NAME}=${wordsCount}`;
}

export const getByoSettingsUrl = (id: any, wordsCount: number) => {
    return `${Routes.byoSetting}?${BYO_SETTINGS_ID_QUERY_PARAM_NAME}=${encodeURIComponent(id)}&${BYO_WORDS_COUNT_QUERY_PARAM_NAME}=${wordsCount}`;
}